@if (getShowForPlaybooks && !isCollapsibleMenu) {
  <div class="left-navigation">
    <ng-scrollbar class="sidebar-scroll">
      <!-- Default -->
      @if (showSidebar == 'generic') {
        <ul>
          <!-- vBuilder -->
          @if (checkCompanyHasVBuilderAccess()) {
            <li
              [ngClass]="{'active': activeModule == 'vbuilder'}">
              <a [routerLink]="['company',companyId,'vbuilder']">
                <i class="material-icons vPlaybookIcons">build</i>vBuilder
              </a>
            </li>
          }
          <!-- Playbooks -->
          @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','VPlaybookReader',
            'CompanyReader','SpecificVPlaybookAdmin','Administrator','PlaybookOwner','User','SalesManager'])) {
            <li style="cursor: pointer;">
              <a [ngClass]="{'active': activeModule == 'playbooks'}" (click)="removeCategoryFilter()"
                [routerLink]="playbookPageUrl()">
                <i class="material-icons vPlaybookIcons">collections_bookmark</i>
                Playbooks
              </a>
              <!-- Playbook Categories -->
              @if (selectedParentModule === 'playbooks') {
                <div class="pc-categories">
                  @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator'])) {
                    <ul class="dropdown--folder pointer"
                      >
                      <li [ngClass]="{'active': activeModule == 'addFolder'}">
                        <a (click)="openFolderModal()">
                          @if (!receivedCgs.length) {
                            <i class="material-icons vPlaybookIcons">create_new_folder</i>
                          }
                          @if (receivedCgs.length) {
                            <i class="material-icons vPlaybookIcons">rule_folder</i>
                          }
                          {{receivedCgs.length ? "Manage Folders": "Add Folder"}}
                        </a>
                      </ul>
                    }
                    <div>
                      @for (category of receivedCgs; track category; let i = $index) {
                        <ul class="dropdown--folder pointer">
                          @if (i < 2 || enableView) {
                            <li [ngClass]="{'active': activeCategory == category.name}">
                              <a (click)="filterPlaybooks(category)">
                                <i class="material-icons vPlaybookIcons" style="left: 34px;">folder</i>
                                <span title="{{category.name}}" class="text-ellipsis">
                                  {{category.name}}
                                </span>
                              </a>
                            </li>
                          }
                        </ul>
                      }
                      @if (receivedCgs.length > 2) {
                        <ul class="dropdown--folder pointer">
                          @if (!enableView) {
                            <li>
                              <a (click)="enableView = true">
                                <i class="material-icons vPlaybookIcons" style="left: 34px;">more_horiz</i>
                                <span class="text-ellipsis">
                                  View More
                                </span>
                              </a>
                            </li>
                          }
                          @if (enableView) {
                            <li>
                              <a (click)="enableView = false">
                                <i class="material-icons vPlaybookIcons" style="left: 34px;">more_horiz</i>
                                <span class="text-ellipsis">
                                  View Less
                                </span>
                              </a>
                            </li>
                          }
                        </ul>
                      }
                    </div>
                  </div>
                }
              </li>
            }
            <!-- LMS -->
            @if ((company?.enableLearningCenterAccess == true) && (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager']) || (showNavigationItem(['User']) && userHasLmsAccess))) {
              <li
                [ngClass]="{'active': isLearningCenterActive == true || (activeModule == 'managerlmsdashboard' && getUserRoleIndex !== 2)}">
                <a href="javascript:void(0);" [routerLink]="getLmsRouterLink('dashboard')">
                  <i class="material-icons vPlaybookIcons">school</i>
                  Learning Center
                </a>
                @if (selectedParentModule === 'lc' && getUserRoleIndex !== 2) {
                  <ul class="dropdown-menu-fixed">
                    <!-- Collection Templates -->
                    @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager']) && getUserRoleIndex !== 3) {
                      <li
                        [ngClass]="{'active': ['adminlmscollectiontemplates','adminlmscollectiontemplateeditor','managerlmscollectiontemplates','managerlmscollectiontemplateeditor'].includes(activeModule)}"
                        >
                        <a [routerLink]="getLmsRouterLink('collectiontemplates')">Collection Templates
                        </a>
                      </li>
                    }
                    <!-- Feedback -->
                    @if (lcFeedbackInfo?.showFeedbackOption) {
                      <li
                        [ngClass]="{'active': activeModule == 'adminlmsfeedback' || activeModule == 'userlmsfeedback' || activeModule == 'managerlmsfeedback'}">
                        <a [routerLink]="getLmsRouterLink('feedback')">Feedback @if (lcFeedbackInfo?.chatCounts > 0) {
                          <span
                          >({{lcFeedbackInfo?.chatCounts}})</span>
                        }
                      </a>
                    </li>
                  }
                  <!-- Colllection Response -->
                  @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager']) && getUserRoleIndex !== 3) {
                    <li
                      [ngClass]="{'active': activeModule == 'admincollectionresponses' ||  activeModule == 'managercollectionresponses'}">
                      <a [routerLink]="getLmsRouterLink('collectionresponses')">Collection Responses
                      </a>
                    </li>
                  }
                  <!-- SCORM -->
                  @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator']) && userEnvironment.serverUrl.includes('staging')) {
                    <li
                      [ngClass]="{'active': activeModule == 'adminlmsscorm'}">
                      <a [routerLink]="getLmsRouterLink('adminlmsscorm')">SCORM Courses
                      </a>
                    </li>
                  }
                  <!-- Leaderboard -->
          <li [ngClass]="{'active': activeModule == 'adminlmsleaderboard' || activeModule == 'userlmsleaderboard' || activeModule == 'managerlmsleaderboard' ||
          activeModule == 'adminlmsparticipantbreakdown'}">
                    <a [routerLink]="getLmsRouterLink('leaderboard')">Leaderboard
                    </a>
                  </li>
                </ul>
              }
              @if (selectedParentModule === 'lc' && getUserRoleIndex === 2) {
                <ul class="dropdown-menu-fixed">
                  <li class="inner-menu d-flex"
                    [ngClass]="{'active': ['managerlmsdashboard','managerlmsviewtemplate','managerlmsedittemplate'].includes(activeModule)}">
                    <a [routerLink]="getLmsRouterLink('dashboard')">My Team’s Collections
                    </a>
                    @if (showPendingScoreNotification) {
                      <span class="pending-notification"></span>
                    }
                  </li>
                  @if (userHasLmsAccess) {
                    <li class="inner-menu"
                      [ngClass]="{'active': ['userlmsdashboard','userlmsviewtemplate'].includes(activeModule)}">
                      <a [routerLink]="getLmsRouterLink('dashboard', true)">My Collections
                      </a>
                    </li>
                  }
                  @if (lcFeedbackInfo?.showFeedbackOption) {
                    <li [ngClass]="{'active': activeModule == 'managerlmsfeedback'}">
                      <a [routerLink]="getLmsRouterLink('feedback')">Feedback @if (lcFeedbackInfo?.chatCounts > 0) {
                        <span
                        >({{lcFeedbackInfo?.chatCounts}})</span>
                      }
                    </a>
                  </li>
                }
                <li
                  [ngClass]="{'active': ['managerlmscollectiontemplates','managerlmscollectiontemplateeditor'].includes(activeModule)}">
                  <a [routerLink]="getLmsRouterLink('collectiontemplates')">Collection Templates
                  </a>
                </li>
                <!-- Colllection Response -->
                <li [ngClass]="{'active':activeModule == 'managercollectionresponses'}">
                  <a [routerLink]="getLmsRouterLink('collectionresponses')">Collection Responses
                  </a>
                </li>
                <li class="inner-menu"
                  [ngClass]="{'active': activeModule == 'manageruserlmsleaderboard' || activeModule == 'managerlmsparticipantbreakdown' }">
                  <a [routerLink]="getLmsRouterLink('my-leaderboard')">Leaderboard
                  </a>
                </li>
              </ul>
            }
          </li>
        }
        <!-- People -->
        @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator'])) {
          <li
            [ngClass]="{'active': activeModule == 'people'}">
            <a href="javascript:void(0);" [routerLink]="['company',companyId,'people']">
              <i class="material-icons vPlaybookIcons">account_circle</i>
              People
            </a>
            @if (selectedParentModule === 'people') {
              <ul class="dropdown-menu-fixed">
                <!-- Tags -->
                <li [ngClass]="{'active': activeModule == 'tags'}">
                  <a [routerLink]="['company',companyId,'people','tags' ]">Tags
                  </a>
                </li>
                <!-- Bulk Actions -->
                <li [ngClass]="{'active': activeModule == 'bulkaction'}">
                  <a [routerLink]="['company',companyId,'people','bulkaction' ]">Bulk Actions
                  </a>
                </li>
                <!-- Upload Help -->
                <li [ngClass]="{'active': activeModule == 'help'}">
                  <a [routerLink]="['company',companyId,'people','help' ]">Upload Help
                  </a>
                </li>
                <!-- About User level -->
                <li [ngClass]="{'active': activeModule == 'roles'}">
                  <a [routerLink]="['company',companyId, 'people','roles' ]">About User Levels
                  </a>
                </li>
                <!-- Hierarchy Map -->
                @if (company?.allowManagerRepHierarchy) {
                  <li [ngClass]="{'active': activeModule == 'hierarchymap'}">
                    <a [routerLink]="['company',companyId,'people','hierarchymap' ]">Hierarchy Map
                    </a>
                  </li>
                }
                <!-- Notifications -->
                <li [ngClass]="{'active': activeModule == 'notification'}">
                  <a [routerLink]="['company',companyId, 'people','notifications' ]">Notifications
                  </a>
                </li>
                <!-- Custom Fields -->
                <li [ngClass]="{'active': activeModule == 'customfields'}"><a
                [routerLink]="['company',companyId,'people','customfields' ]">Custom Fields</a></li>
                <!-- Permissions Groups -->
                @if (company?.allowPermissionGroups || company?.enableUserTypePermissionGroup) {
                  <li
                    [ngClass]="{'active': activeModule == 'permissionsgroups'}"><a
                  [routerLink]="['company',companyId,'people','permissionsgroups' ]">Permission Groups</a></li>
                }
              </ul>
            }
          </li>
        }
        <!-- Reports -->
        @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager']) && checkCompanyHasReportAccess()) {
          <li [ngClass]="{'active': activeModule == 'reportinsightsdashboard'}"
            >
            <a [routerLink]="['company',companyId, 'insights' ]" href="javascript:void(0);">
              <i class="material-icons vPlaybookIcons">assessment</i>
              Insights
            </a>
            @if (selectedParentModule === 'reports') {
              <ul class="dropdown-menu-fixed">
                <!-- Scheduled Reports -->
                @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager'])) {
                  <li
                    [ngClass]="{'active': activeModule == 'report'}">
                    <a [routerLink]="['company',companyId, 'insights', 'report' ]"> Reports</a>
                  </li>
                }
                <!-- Scheduled Reports -->
                @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager'])) {
                  <li
                    [ngClass]="{'active': activeModule == 'scheduledreport'}">
                    <a [routerLink]="['company',companyId, 'insights', 'schedule' ]">Scheduled Reports</a>
                  </li>
                }
                <!-- Report Description -->
                @if (showNavigationItem(['SuperVPlaybookAdmin'])) {
                  <li
                    [ngClass]="{'active': activeModule == 'reportdescription'}">
                    <a [routerLink]="['company',companyId, 'insights', 'reportdescription' ]">Report
                    Description</a>
                  </li>
                }
              </ul>
            }
          </li>
        }
        <!-- Company Assets -->
        @if (showNavigationItem(['SuperVPlaybookAdmin'])) {
          <li [ngClass]="{'active': activeModule == 'assets'}">
            <a [routerLink]="['company',companyId,'assets' ]">
              <i class="material-icons vPlaybookIcons">perm_media</i>
              Assets
            </a>
          </li>
        }
        <!-- Company Conversation/Page Templates -->
        @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator'])) {
          <li [ngClass]="{'active': activeModule == 'companytemplates'}"
            >
            <a [routerLink]="['company',companyId,'templates', 'conversation' ]">
              <i class="material-icons vPlaybookIcons">message</i>
              Templates
            </a>
            @if (selectedParentModule === 'companytemplates') {
              <ul class="dropdown-menu-fixed">
                <!-- Conversation Templates -->
                <li [ngClass]="{'active': activeModule == 'companyconvtemplates'}">
                  <a [routerLink]="['company',companyId, 'templates', 'conversation' ]">Conversation Templates</a>
                </li>
                <!-- Page Templates -->
                <li [ngClass]="{'active': activeModule == 'companypagetemplates'}">
                  <a [routerLink]="['company',companyId, 'templates', 'page' ]">Page Templates</a>
                </li>
                <!-- Page Templates -->
                <li [ngClass]="{'active': activeModule == 'companyplaybooktemplates'}">
                  <a [routerLink]="['company',companyId, 'templates', 'playbook' ]">Playbook Templates</a>
                </li>
              </ul>
            }
          </li>
        }
        <!-- Coaching -->
        @if (company?.hasCoachingAccess && userHasCoachingRights()
          && showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager','User'])) {
          <li
        [ngClass]="{'active': activeModule == 'admindashboard'
      || (activeModule == 'coachingdashboard' && !viewingAsManagerId)
      || (activeModule == 'repcoachingdashboard' && getUserRoleIndex !== 2)}">
            <a href="javascript:void(0);" [routerLink]="getCoachingRouterLink('dashboard')">
              <i class="material-icons vPlaybookIcons">assignment_ind</i>
              Coaching
            </a>
            @if (selectedParentModule === 'coaching' && getUserRoleIndex !== 2 && !viewingAsManagerId) {
              <ul
                class="dropdown-menu-fixed">
                <li>
                  <a [ngClass]="{'active': activeModule == 'adminchallenges' || activeModule == 'challenges' || activeModule == 'repchallenges'}"
                    href="javascript:void(0);"
                  [routerLink]="getCoachingRouterLink('challenges')">Challenges</a>
                </li>
                @if (getUserRoleIndex == 1) {
                  <li>
                    <a [ngClass]="{'active': activeModule == 'teamassessment'}" href="javascript:void(0);"
                    [routerLink]="getCoachingRouterLink('teamassessment')">Team Assessment</a>
                  </li>
                }
                <li>
                  <a [ngClass]="{'active': activeModule == 'adminleaderboard' || activeModule == 'coachingleaderboard' || activeModule == 'repleaderboard'}"
                  href="javascript:void(0);" [routerLink]="getCoachingRouterLink('leaderboard')">Leaderboard</a>
                </li>
                <li>
                  <a [ngClass]="{'active': activeModule == 'adminfeaturedcontent' || activeModule == 'featuredcontent' || activeModule == 'repfeaturedcontent'}"
                  href="javascript:void(0);" [routerLink]="getCoachingRouterLink('featuredcontent')">Featured Content</a>
                </li>
                @if (getUserRoleIndex == 0 || getUserRoleIndex == 1) {
                  <li>
                    <a [ngClass]="{'active': activeModule == 'challengeresponses'}" href="javascript:void(0);"
                    [routerLink]="getCoachingRouterLink('challengeresponses')">Challenge Responses</a>
                  </li>
                }
                @if (getUserRoleIndex == 0 || getUserRoleIndex == 1) {
                  <li>
                    <a [ngClass]="{'active': activeModule == 'challengestemplate' || activeModule == 'challengetemplate'}"
                      href="javascript:void(0);" [routerLink]="getCoachingRouterLink('challengestemplate')">Challenge
                    Templates</a>
                  </li>
                }
                @if (getUserRoleIndex !== 0) {
                  <li>
                    <a [ngClass]="{'active': activeModule == 'challengefeedback' || activeModule == 'repfeedback'}"
                    href="javascript:void(0);" [routerLink]="getCoachingRouterLink('feedback')">Feedback</a>
                  </li>
                }
              </ul>
            }
            @if (selectedParentModule === 'coaching' && getUserRoleIndex === 2 && !viewingAsManagerId) {
              <ul
                class="dropdown-menu-fixed-manager-rep">
                <!-- Manager Nav -->
                <li class="inner-menu">
                  <a href="javascript:void(0);" (click)="showManagerNav = !showManagerNav">
                    <i class="material-icons vPlaybookIcons dropdown-icons"
                    [ngClass]="{'open': showManagerNav}">arrow_right</i>
                    Your Team
                  </a>
                </li>
                @if (showManagerNav) {
                  <li>
                    <a [ngClass]="{'active': activeModule == 'challenges'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/challenges'">Challenges</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'teamassessment'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/teamassessment'">Team Assessment</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'coachingleaderboard'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/leaderboard'">Leaderboard</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'featuredcontent'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/featuredcontent'">Featured Content</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'challengeresponses'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/challengeresponses'">Challenge Responses</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'challengestemplate'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/challengestemplate'">Challenge Templates</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'challengefeedback'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/challengefeedback'">Feedback</a>
                  </li>
                }
                <!-- Rep Nav -->
                <li class="inner-menu">
                  <a href="javascript:void(0);" (click)="showRepNav = !showRepNav">
                    <i class="material-icons vPlaybookIcons dropdown-icons" [ngClass]="{'open': showRepNav}">arrow_right</i>
                    You
                  </a>
                </li>
                @if (showRepNav) {
                  <li>
                    <a [ngClass]="{'active': activeModule == 'repcoachingdashboard'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/rep/coachingdashboardrep'">Dashboard</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'repchallenges'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/rep/challenges'">Challenges</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'repleaderboard'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/rep/leaderboard'">Leaderboard</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'repfeaturedcontent'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/rep/featuredcontent'">Featured Content</a>
                  </li>
                  <li>
                    <a [ngClass]="{'active': activeModule == 'repfeedback'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/rep/challengefeedback'">Feedback</a>
                  </li>
                }
              </ul>
            }
            @if (viewingAsManagerId) {
              <ul class="dropdown-menu-fixed">
                <li>
                  <a [ngClass]="{'active': activeModule == 'coachingdashboard'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/coachingdashboard'"
                  [queryParams]="{mid: viewingAsManagerId}">Dashboard</a>
                </li>
                <li>
                  <a [ngClass]="{'active': activeModule == 'challenges'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/challenges'"
                  [queryParams]="{mid: viewingAsManagerId}">Challenges</a>
                </li>
                <li>
                  <a [ngClass]="{'active': activeModule == 'teamassessment'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/teamassessment'"
                  [queryParams]="{mid: viewingAsManagerId}">Team Assessment</a>
                </li>
                <li>
                  <a [ngClass]="{'active': activeModule == 'coachingleaderboard'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/leaderboard'"
                  [queryParams]="{mid: viewingAsManagerId}">Leaderboard</a>
                </li>
                <li>
                  <a [ngClass]="{'active': activeModule == 'challengeresponses'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/challengeresponses'"
                  [queryParams]="{mid: viewingAsManagerId}">Challenge Responses</a>
                </li>
                <li>
                  <a [ngClass]="{'active': activeModule == 'featuredcontent'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/featuredcontent'"
                  [queryParams]="{mid: viewingAsManagerId}">Featured Content</a>
                </li>
                <li>
                  <a [ngClass]="{'active': activeModule == 'challengefeedback'}" href="javascript:void(0);"
                    [routerLink]="'company/' + companyId +'/manager/challengefeedback'"
                  [queryParams]="{mid: viewingAsManagerId}">Feedback</a>
                </li>
              </ul>
            }
          </li>
        }
      </ul>
    }
    <!-- Settings -->
    @if (showSidebar == 'settings') {
      <ul class="left-side-nav">
        <li [ngClass]="{'gradient': activeModule == 'userguide'}">
          <a id="userguide" [routerLink]="['settings', 'userguide']">
            <i class="material-icons vPlaybookIcons ">assignment</i>User Guide Settings
          </a>
        </li>
        <li [ngClass]="{'gradient': activeModule == 'releasenotifications'}">
          <a id="releasenotifications" [routerLink]="['settings', 'releasenotifications']">
            <i class="material-icons vPlaybookIcons ">notification_important</i>Release Notifications
          </a>
        </li>
        <li [ngClass]="{'gradient': activeModule == 'applicationversion'}">
          <a id="applicationversion" [routerLink]="['settings', 'applicationversion']">
            <i class="material-icons vPlaybookIcons ">cloud_download</i>Application Version
          </a>
        </li>
      </ul>
    }
    <!-- Templates -->
    @if (showSidebar == 'templates') {
      <ul>
        <li [ngClass]="{'active': activeModule == 'templates'}">
          <a id="templates" [routerLink]="['templates']">
            <i class="material-icons vPlaybookIcons ">table_chart</i>Page Templates
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'reportdescriptiontemplate'}">
          <a id="reportdescription" [routerLink]="['reportdescription']">
            <i class="material-icons vPlaybookIcons ">add_alert</i>Report Description
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'coachingchallenges'}">
          <a id="coachingchallenges" [routerLink]="['templates', 'coachingchallenges']">
            <i class="material-icons vPlaybookIcons ">assignment_turned_in</i>Coaching Challenges
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'adminteamassessment'}">
          <a id="teamassessments" [routerLink]="['templates','adminteamassessment']">
            <i class="material-icons vPlaybookIcons ">message</i>Team Assessments
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'playbooktemplatecompanies'}">
          <a id="teamassessments" [routerLink]="['templates','playbooktemplates']">
            <i class="material-icons vPlaybookIcons ">collections_bookmark</i>Playbook Templates
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'badges'}">
          <a id="badges" [routerLink]="['templates','badges']">
            <i class="material-icons vPlaybookIcons ">verified</i>Platform Badges
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'learningcenter' || activeModule == 'collectiontemplateeditor'}">
          <a id="learningcenter" [routerLink]="['templates','learning-center']">
            <i class="material-icons vPlaybookIcons ">school</i>Learning Center
          </a>
        </li>
      </ul>
    }
    <!-- Admin -->
    @if (showSidebar == 'admins') {
      <ul>
        <li [ngClass]="{'active': activeModule == 'admins'}">
          <a id="admins" [routerLink]="['people']">
            <i class="material-icons vPlaybookIcons ">account_circle
            </i>Admins
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'aboutuserlevels'}">
          <a id="aboutuserlevels" [routerLink]="['people','roles']">
            About User Levels
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'searchall'}">
          <a id="searchall" [routerLink]="['people','searchall']">
            Search All Companies
          </a>
        </li>
        <li [ngClass]="{'active': activeModule == 'adminreports'}">
          <a id="adminreports" [routerLink]="['people','adminreports']">
            Admin Reports
          </a>
          <!-- All navigation logic for scheduled reports are set, just uncomment this code when you start with implementation -->
          <!-- <ul *ngIf="selectedParentModule === 'adminReport'" class="dropdown-menu-fixed">
          <li
            *ngIf="showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin'])"
            [ngClass]="{'active': activeModule == 'scheduleadminreports'}">
            <a [routerLink]="['people','scheduleadminreports']">Scheduled Reports</a>
          </li>
        </ul> -->
      </li>
    </ul>
  }
</ng-scrollbar>
@if (isDisplayDownloadMenu) {
  <div>
    <div class="bottom-app-btn hidden-xs" [ngClass]="{'footer-download' : !showPlaybookBranding}">
      <!-- Split button -->
      <div class="dropup" id="download-dropdown">
        <div class="btn-group text-center">
          <a type="button" [href]="downloadOsUrl" download class="btn width-80"
          id="download_btn_name">{{downoadOsTitle}} </a>
          <button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false"> <span class="icon-caret-down"></span> <span
          class="visually-hidden">Toggle Dropdown</span>
        </button>
        <ul class="dropdown-menu">
          <li>
            <a [href]="winAppUrl" download><img class="win-icon"
              src="assets/img/sidebar/windows.svg" />Download for
            Windows</a>
          </li>
          <li>
            <a [href]="macAppUrl" download><img class="apple-icon"
              src="assets/img/sidebar/apple.svg" />Download for
            Mac</a>
          </li>
          <li>
            <a [href]="iosAppUrl" download><img class="apple-icon"
              src="assets/img/sidebar/apple.svg" />Download for
            IOS</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
}
@if (showPlaybookBranding) {
  <div class="footer">
    <img src="assets/img/vPlaybook-logo_color_sm.png" class="img-fluid">
  </div>
}
</div>
}
@if (getShowForPlaybooks && isCollapsibleMenu) {
  <div class="left-navigation collapsible-div">
    <ng-scrollbar class="sidebar-scroll">
      <!-- Default -->
      @if (showSidebar == 'generic') {
        <ul>
          <!-- vBuilder -->
          @if (checkCompanyHasVBuilderAccess()) {
            <li
              [ngClass]="{'active': activeModule == 'vbuilder'}">
              <a [routerLink]="['company',companyId,'vbuilder']">
                <i class="material-icons vPlaybookIcons">build</i>
              </a>
            </li>
          }
          <!-- Playbooks -->
          @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','VPlaybookReader',
            'CompanyReader','SpecificVPlaybookAdmin','Administrator','PlaybookOwner','User','SalesManager'])) {
            <li style="cursor: pointer;">
              <a [ngClass]="{'active': activeModule == 'playbooks'}" (click)="removeCategoryFilter()"
                [routerLink]="playbookPageUrl()">
                <i class="material-icons vPlaybookIcons">collections_bookmark</i>
              </a>
            </li>
          }
          <!-- Playbooks -->
          @if ((company?.enableLearningCenterAccess == true) && (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager']) || (showNavigationItem(['User']) && userHasLmsAccess))) {
            <li style="cursor: pointer;"
              >
              <a [ngClass]="{'active': isLearningCenterActive}" (click)="removeCategoryFilter()"
                [routerLink]="getLmsRouterLink('dashboard')">
                <i class="material-icons vPlaybookIcons">school</i>
              </a>
            </li>
          }
          <!-- People -->
          @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator'])) {
            <li
              [ngClass]="{'active': activeModule == 'people'}">
              <a href="javascript:void(0);" [routerLink]="['company',companyId,'people']">
                <i class="material-icons vPlaybookIcons">account_circle</i>
              </a>
            </li>
          }
          <!-- Reports -->
          @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager']) && checkCompanyHasReportAccess()) {
            <li [ngClass]="{'active': activeModule == 'report'}"
              >
              <a [routerLink]="['company',companyId, 'reports' ]" href="javascript:void(0);">
                <i class="material-icons vPlaybookIcons">assessment</i>
              </a>
            </li>
          }
          <!-- Company Assets -->
          @if (showNavigationItem(['SuperVPlaybookAdmin'])) {
            <li [ngClass]="{'active': activeModule == 'assets'}">
              <a [routerLink]="['company',companyId,'assets' ]">
                <i class="material-icons vPlaybookIcons">perm_media</i>
              </a>
            </li>
          }
          <!-- Company Conversation/Page Templates -->
          @if (showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator'])) {
            <li [ngClass]="{'active': activeModule == 'conversationtemplates'}"
              >
              <a [routerLink]="['company',companyId,'templates' ]">
                <i class="material-icons vPlaybookIcons">message</i>
              </a>
            </li>
          }
          <!-- Coaching -->
          @if (company?.hasCoachingAccess && userHasCoachingRights()
            && showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','Administrator','SalesManager','User'])) {
            <li
        [ngClass]="{'active': activeModule == 'admindashboard'
      || (activeModule == 'coachingdashboard' && !viewingAsManagerId)
      || (activeModule == 'repcoachingdashboard' && getUserRoleIndex !== 2)}">
              <a href="javascript:void(0);" [routerLink]="getCoachingRouterLink('dashboard')">
                <i class="material-icons vPlaybookIcons">assignment_ind</i>
              </a>
            </li>
          }
        </ul>
      }
      <!-- Settings -->
      @if (showSidebar == 'settings') {
        <ul class="left-side-nav">
          <li [ngClass]="{'gradient': activeModule == 'userguide'}">
            <a id="userguide" [routerLink]="['settings', 'userguide']">
              <i class="material-icons vPlaybookIcons ">assignment</i>
            </a>
          </li>
          <li [ngClass]="{'gradient': activeModule == 'releasenotifications'}">
            <a id="releasenotifications" [routerLink]="['settings', 'releasenotifications']">
              <i class="material-icons vPlaybookIcons ">notification_important</i>
            </a>
          </li>
          <li [ngClass]="{'gradient': activeModule == 'applicationversion'}">
            <a id="applicationversion" [routerLink]="['settings', 'applicationversion']">
              <i class="material-icons vPlaybookIcons ">cloud_download</i>
            </a>
          </li>
        </ul>
      }
      <!-- Templates -->
      @if (showSidebar == 'templates') {
        <ul>
          <li [ngClass]="{'active': activeModule == 'templates'}">
            <a id="templates" [routerLink]="['templates']">
              <i class="material-icons vPlaybookIcons ">table_chart</i>
            </a>
          </li>
          <li [ngClass]="{'active': activeModule == 'reportdescriptiontemplate'}">
            <a id="reportdescription" [routerLink]="['reportdescription']">
              <i class="material-icons vPlaybookIcons ">add_alert</i>
            </a>
          </li>
          <li [ngClass]="{'active': activeModule == 'coachingchallenges'}">
            <a id="coachingchallenges" [routerLink]="['templates', 'coachingchallenges']">
              <i class="material-icons vPlaybookIcons ">assignment_turned_in</i>
            </a>
          </li>
          <li [ngClass]="{'active': activeModule == 'adminteamassessment'}">
            <a id="teamassessments" [routerLink]="['templates','adminteamassessment']">
              <i class="material-icons vPlaybookIcons ">message</i>
            </a>
          </li>
        </ul>
      }
      <!-- Admin -->
      @if (showSidebar == 'admins') {
        <ul>
          <li [ngClass]="{'active': activeModule == 'admins'}">
            <a id="admins" [routerLink]="['people']">
              <i class="material-icons vPlaybookIcons ">account_circle
              </i>
            </a>
          </li>
        </ul>
      }
    </ng-scrollbar>
    @if (showPlaybookBranding) {
      <div class="footer_collapsed">
        <img src="assets/img/v_logo.png" class="img-fluid">
      </div>
    }
  </div>
}
@if (selectedParentModule === 'playbooks' && getShowForPlaybooks && receivedCgs && receivedCgs.length &&
  showNavigationItem(['SuperVPlaybookAdmin','StandardVPlaybookAdmin','VPlaybookReader',
  'CompanyReader','SpecificVPlaybookAdmin','Administrator','PlaybookOwner','User','SalesManager'])) {
  <div class="left-navigation mobile-categories">
    @if (showSidebar == 'generic') {
      <ng-scrollbar class="sidebar-scroll">
        <ul>
          @for (category of receivedCgs; track category; let i = $index) {
            <li style="cursor: pointer;"
              [ngClass]="{'active': activeCategory == category.name}">
              <a (click)="filterPlaybooks(category)">
                <i class="material-icons vPlaybookIcons" style="display: block; margin-top: 2px;">folder</i>
                <span title="{{category.name}}" class="text-ellipsis">
                  {{category.name}}
                </span>
              </a>
            </li>
          }
        </ul>
      </ng-scrollbar>
    }
  </div>
}
<div class="clearfix"></div>